export default {
  get: function(name) {
    const cookies = document.cookie.split(";");
    for (const cookie of cookies) {
      const cookieKeyValuePair = cookie.split("=");
      const cookieKey = cookieKeyValuePair[0].trim();
      const cookieValue = cookieKeyValuePair[1];
      if (cookieKey == name) {
        return cookieValue;
      }
    }
  },

  set: function(name, value) {
    var expires = "expires=" + this.createExpirationDate();
    let cookieStr = `${name}=${value};${expires};`;
    if (process.env.NODE_ENV === 'production') {
      cookieStr += 'domain=moma.org;';
    }
    document.cookie = cookieStr;
  },

  createExpirationDate: function() {
    var date = new Date();
    date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
    return date.toGMTString();
  }
};
